import { uploadFileSliceDispatch } from "../../Constants/ReduxConstants";

interface UploadFileState {
    apiResponse: string
}

//Every reducer needs initial state.
const initialState: UploadFileState = {
    apiResponse: ""
}

export default function uploadFileSlice(state = initialState, action: { type: any; payload: any; }) {
    switch (action.type) {
        case uploadFileSliceDispatch.setApiResponse: {
            return {
                ...state,
                apiResponse: action.payload
            }
        }
        default:
            return state
    }
}